import Logger from 'logger';
import { API_V1 } from './APIs/APIv1';
import _ from 'lodash';

export const getCountries = async (language: string) => {
  try {
    const lang = language === 'de' ? 'deu' : undefined;

    const response = await API_V1.get('/misc/countries', {
      params: { lang },
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting country list!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
